export const ADD_Cat_LOADING = 'ADD_C_LOADING'
export const ADD_Cat_ERROR = 'ADD_C_ERROR'
export const ADD_Cat_SUCCESS = 'ADD_C_SUCCESS'
export const UPDATE_ERROR_Cat = 'UPDATE_ERROR'
export const UPDATE_SUCCESS_Cat = 'UPDATE_SUCCESS'
export const DELETE_Cat = 'DELETE_COLLECTION'
export const CLEAR_NOTIF_STATE = 'CLEAR_NOTIF_STATE'
